<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              v-model="filter_departments"
              collapse-tags
              filterable
              placeholder="Departamentos"
              @change="cleanSelect"
              multiple>
              <el-option
                class="select-default"
                v-for="item in departments"
                :key="item.CodeDpto"
                :label="item.NameDpto"
                :value="item.CodeDpto">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              multiple
              filterable
              placeholder="Municipios"
              collapse-tags
              v-model="filter_municipalities">
              <el-option
                class="select-default"
                v-for="item in municipalities"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-date-picker
              style="width: 100%"
              :clearable="false"
              v-model="rangeDate"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="Fecha Inicial"
              end-placeholder="Fecha Final"
              align="center">
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-3 text-center">
              <br class="c-none">
              <button type="button" class="btn btn-warning" @click="getFilteredData">Filtrar Datos</button>
          </div>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div v-if="canIndex()">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-3 col-md-2 col-lg-3">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-6 col-md-7 col-lg-6">
                <div class="mr-1 pull-right" v-if="canExcel()">
                  <img ref="supports"
                    class="img-exports-block"
                    src="/static/img/icons/docs/files_gray.svg"
                    alt="soportes"
                    v-tooltip="'Descargar Soportes'">
                </div>
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('PQRS_Mantenimientos', 'PQRS y Mantenimiento', 'a2', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('PQRS_Mantenimientos', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('PQRS_Mantenimientos', tableData, tableColumnsAll, 1)">
                </div>
              </div>
              <div class="col-6 col-sm-3 col-md-3 col-lg-3">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      @selection-change="handleSelectionChange"
                      border
                      ref="tableModule">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :formatter="column.formatter"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                label="Acciones">
                <template slot-scope="props">
                  <a v-if="canShow()" v-tooltip.top-center="'Ver'" class="btn-info btn-simple btn-link"
                     @click="handleView(props.$index, props.row)">
                    <i class="fa fa-eye"></i></a>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                type="selection"
                width="55">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <div class="text-center">
        <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('PQRS_Mantenimientos', 'PQRS y Mantenimiento', 'a2', tableData, tableColumnsAll, 1)"><i class="fa fa-file-pdf-o"></i>
            Exportar a PDF
        </button>
      </div>
    </div>
    <div class="col-3">
      <div class="text-center">
        <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('PQRS_Mantenimientos', tableData, tableColumnsAll, 1)"><i class="fa fa-file-excel-o"></i>
        Exportar a Excel
      </button>
      </div>
    </div>
    <div class="col-3">
      <div class="text-center">
        <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('PQRS_Mantenimientos', tableData, tableColumnsAll, 1)"><i class="fa fa-file-text-o"></i>
          Exportar a CSV
        </button>
      </div>
    </div>
    <div class="col-3">
      <div class="text-center">
        <button v-bind:disabled="multipleSelection.length == 0" @click="donwloadSuports()" class="btn btn-secondary btn-fg custom-shadow-btn"><i class="fa fa-download"></i>
          Descargar Soportes
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <el-dialog v-if="canShow()"
      :title="title"
      :visible.sync="modals.read">
        <p>A continuación encontrarás toda la información asociada al registro seleccionado.</p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <table class="table">
              <tbody v-if="rowData">
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Región:</b></h6>
                      {{rowData.Region}}
                    </td>
                    <td scope="row">
                      <h6><b>Departamento:</b></h6>
                      {{rowData.NameDpto}}
                    </td>
                    <td scope="row">
                      <h6><b>Municipio:</b></h6>
                      {{rowData.NMunicipio}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Barrio:</b></h6>
                      {{rowData.Barrio}}
                    </td>
                    <td scope="row">
                      <h6><b>Drección:</b></h6>
                      {{rowData.Dirección}}
                    </td>
                    <td scope="row">
                      <h6><b>ID Punto:</b></h6>
                      {{rowData.IDPunto}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Cédula:</b></h6>
                      {{rowData.Cedula}}
                    </td>
                    <td scope="row">
                      <h6><b>Solicitante:</b></h6>
                      {{rowData.Solicitante}}
                    </td>
                    <td scope="row">
                      <h6><b>Telefono:</b></h6>
                      {{rowData.Telefono}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Email:</b></h6>
                      {{rowData.Email}}
                    </td>
                    <td scope="row">
                      <h6><b>Coordenadas:</b></h6>
                      {{rowData.Coordenadas}}
                    </td>
                    <td scope="row">
                      <h6><b>Origen:</b></h6>
                      {{rowData.Origen}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Nro. Ticket:</b></h6>
                      {{rowData.NroTiket}}
                    </td>
                    <td scope="row">
                      <h6><b>Tipo:</b></h6>
                      {{rowData.TipoEvento}}
                    </td>
                    <td scope="row">
                      <h6><b>Fecha Reporte:</b></h6>
                      {{rowData.FechaReport}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Prioridad:</b></h6>
                      {{rowData.Prioridad}}
                    </td>
                    <td scope="row">
                      <h6><b>Encargado:</b></h6>
                      {{rowData.Encargado}}
                    </td>
                    <td scope="row">
                      <h6><b>Fecha Limite Cierre:</b></h6>
                      {{rowData.FecLimCierre}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Fecha Cierre:</b></h6>
                      {{rowData.FecCierre}}
                    </td>
                    <td scope="row">
                      <h6><b>Estado Reporte:</b></h6>
                      {{rowData.EstadoReporte}}
                    </td>
                  </tr>
              </tbody>
              <tfoot>
                <tr class="shadow-sm">
                    <td colspan="3">
                      <h6><b>Descripción:</b></h6>
                      {{rowData.Observaciones}}
                    </td>
                </tr>
                <tr class="shadow-sm">
                    <td colspan="3">
                      <h6><b>Descripción de la Solución Tipificada:</b></h6>
                      {{rowData.DescripcionST}}
                    </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </el-dialog>
    </div>
    <br/>
      <div class="row">
        <div class="col-md-12">
          <card class="custom-shadow-card-header">
            <div slot="header" class="text-center">
              <h4 class="card-title">Grafica 1</h4>
            </div>
            <span v-if="Object.keys(chartOptions1).length > 0">
              <div class="row">
                <div class="col-12">
                  <highcharts :options="chartOptions1"></highcharts>
                </div>
              </div>
            </span>
            <div slot="footer" class="text-left">
              <p class="card-category"><i class="fa fa-clock-o"></i> Ultimo actualización {{currentTime}}</p>
            </div>
          </card>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-md-12">
          <card class="custom-shadow-card-header">
            <div slot="header" class="text-center">
              <h4 class="card-title">Grafica 2</h4>
            </div>
            <span v-if="Object.keys(chartOptions2).length > 0">
              <div class="row">
                <div class="col-12">
                  <highcharts :options="chartOptions2"></highcharts>
                </div>
              </div>
            </span>
            <div slot="footer" class="text-left">
              <p class="card-category"><i class="fa fa-clock-o"></i> Ultimo actualización {{currentTime}}</p>
            </div>
          </card>
        </div>
      </div>
  </div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinCharts from 'src/util/mixinCharts'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import showSwalAlert from 'src/util/alerts'
  import swal from 'sweetalert2'
  import axios from 'axios'
  import moment from 'moment'
  import table from './pqrsMaintenanceTable'
  import store from '@/store'
  import {Chart} from 'highcharts-vue'
  import Highcharts from 'highcharts'
  import exportingInit from 'highcharts/modules/exporting'
  import {StatsCard} from 'src/components/index'

  exportingInit(Highcharts)

  export default {
    components: {
      StatsCard,
      highcharts: Chart
    },
    data () {
      return {
        demandsForm: {},
        departments: [],
        municipalities: [],
        filter_departments: [],
        filter_municipalities: [],
        multipleSelection: [],
        tableColumns: table[0],
        tableColumnsAll: table,
        isShow: true,
        rangeDate: [new Date((new Date().getFullYear()), 0, 1), new Date((new Date().getFullYear()), 11 + 1, 0)],
        currentTime: moment().format('hh:mm:ss'),
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        chartOptions1: {},
        chartOptions2: {},
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker, mixinCharts],
    methods: {
      handleView (index, row) {
        this.isShow = true
        this.rowData = Object.assign({}, row)
        this.title = this.rowData.name
        this.modals['read'] = true
      },
      getFilteredData() {
        let self = this
        this.$emit('cotentLoading', true)

        let data = {}
        data.route ='pqr/index'
        data.filter_municipalities = (this.filter_municipalities.length == 0) ? '' : this.filter_municipalities.join()
        data.filter_departments = (this.filter_departments.length == 0) ? '' : this.filter_departments.join()
        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')

        this.saveMaster(data).then((response) => {
          self.tableData = response.data.pqrsMaintenance
          self.departments = response.data.departments
          self.municipalities = response.data.municipalities
          self.chartOptions1 = self.columns(response.data.chart1, null)
          self.chartOptions2 = self.columns(response.data.chart2, null)
          self.searchFuse([
            'NameDpto', 'Region', 'NMunicipio', 'IDPunto', 'Cedula', 'NroTiket', 'TipoEvento', 'FechaReport', 'EstadoReporte', 'Depart_Code', 'MunCode'
          ])
          self.$emit('cotentLoading', false)
        }).catch((error) => {
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },
      handleSelectionChange(val) {
        if (val.length == 0) {
          this.multipleSelection = []
          this.$refs.supports.src = this.$refs.supports.src.replace('_color', '_gray')
          this.$refs.supports.style = 'cursor:not-allowed;'
          this.$refs.supports.removeEventListener('click', this.donwloadSuports)
        } else {
          this.$refs.supports.src = this.$refs.supports.src.replace('_gray', '_color')
          this.$refs.supports.style = 'cursor:pointer;'
          this.$refs.supports.addEventListener('click', this.donwloadSuports)
        }

        for (let index = 0; index < val.length; index++) {
          const element = val[index];
          if (!this.multipleSelection.includes(element.NroTiket))
            this.multipleSelection.push(element.NroTiket)
        }
      },
      donwloadSuports() {
        let next = false
        if (this.multipleSelection.length == 0) {
          showSwalAlert(
            'Iniciando descarga ...',
            0, false, 'Aceptar', 'Esta operación contiene ' + this.pagination.total + ' registros, lo que implica que su descarga tardara más tiempo de lo esperado. Estas seguro de continuar?', null, null
          ).then((result) => {
            if (result.value) {
              next = true
            }
          })
        } else {
          next = true
        }

        if (next) {
          let self = this
          showSwalAlert(
            'Espere mientras el o los archivos se descargan.',
              null, false, null, null, null, swal
          )

          return axios({
              url: '/auth/pqr/download',
              data: {user: store.state.auth.user.id, multipleSelection : (self.multipleSelection.length == 0) ? '' : self.multipleSelection.join(), filter_municipalities: (self.filter_municipalities.length == 0) ? '' : self.filter_municipalities.join(), filter_departments: (self.filter_departments.length == 0) ? '' : self.filter_departments.join()},
              method: 'POST',
              responseType: 'blob',
          }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'Soportes.zip');
              document.body.appendChild(link);
              link.click();
              swal.close()
          }).catch((error) => self.showMessageErrors(error, 1))
        }
      },
    },
    created(){
      this.$emit('cotentLoading', true)
      if(this.canIndex()){
        this.getFilteredData()
      }
    },
  }
</script>
<style>
</style>
